// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_AcceptResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_AcceptResponse — POST /subscriptions/terms/accept.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubscriptionTerms_AcceptResponseDados {
acceptance_id: number
term_id: number
accepted_at: string
}

export type SubscriptionTerms_AcceptResponse = ApiResponse<SubscriptionTerms_AcceptResponseDados>;

registerResponseContract('SubscriptionTerms_AcceptResponse', {
  acceptance_id: { type: 'number',  required: true },
  term_id:       { type: 'number',  required: true },
  accepted_at:   { type: 'string',  required: true },
})
